import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
@Component({
    selector: 'app-info-tile',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './info-tile.component.html',
    styleUrl: './info-tile.component.scss'
})
export class InfoTileComponent {
    @Input() infoName!: string;
    @Input() infoValue!: Number;
    @Input() disableBackground = false;
}
